import { injectIntl } from 'react-intl';
import {
    Dialog,
    ScreenMessagePanelContainer,
    Label,
    ButtonStandard,
    ButtonLight,
    formatMessage,
    Flexbox,
    RadioButton,
} from 'cw-ui-core';
import css from './NewDeleteUserDialog.scss';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React from 'react';

export const NEW_DELETE_USER_DIALOG = 'NEW_DELETE_USER_DIALOG';

const NewDeleteUserDialog = ({
    deleteOptions,
    option,
    onChangeOption,
    onCancel,
    onOk,
    disableApply,
    usersCount = 0,
}) => {
    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={onCancel}
        />,
        <ButtonStandard
            key="ok"
            automationName="ok"
            className={css.deleteButton}
            value={formatMessage(Locale.apply)}
            onClick={onOk}
            disabled={disableApply}
        />,
    ];

    return (
        <Dialog dialogId={NEW_DELETE_USER_DIALOG} header={formatMessage(Locale.deleteUser)} buttons={dialogButtons}>
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer className={css.screenMessage} screenKey={NEW_DELETE_USER_DIALOG} />
                    <Label value={formatMessage(Locale.deleteUserConfirmation)} />
                    <div className={css.userCountText}>{formatMessage(Locale.usersSelected, { usersCount })}</div>
                    <Flexbox className={css.radioButtonsContainer}>
                        <RadioButton
                            automationName="disableUsers"
                            value={{
                                id: deleteOptions[0].id,
                                name: deleteOptions[0].name,
                                checked: option === deleteOptions[0].id,
                            }}
                            onChange={onChangeOption}
                        />
                        <RadioButton
                            automationName="deleteUsers"
                            value={{
                                id: deleteOptions[1].id,
                                name: deleteOptions[1].name,
                                checked: option === deleteOptions[1].id,
                            }}
                            onChange={onChangeOption}
                        />
                    </Flexbox>
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(NewDeleteUserDialog);
